import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import user from './modules/user'
// import permission from './modules/permission'
import drive from './modules/drive'
import group from './modules/group'
import grouplist from './modules/grouplist'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    user,
    drive,
    grouplist,
    group
    // permission
  },
  getters,
  strict: true
})
